import type { Lesson } from '../schema.js';
import { MOVE_LESSONS } from './moves.js';
import { OBJECTIVE_LESSONS } from './objectives.js';
import { PIECE_POWER_LESSONS } from './piece-power.js';
import { RULES_LESSONS } from './rules.js';
import { CROWNING_LESSONS } from './crowning.js';
import { BACKGAMMON_LESSONS } from './backgammon.js';
import { BRIDGE_LESSONS } from './bridge.js';
import { WHIST_LESSONS } from './whist.js';
import { RUMMY_LESSONS } from './rummy.js';
import { PIRATE_LESSONS } from './pirate.js';
import { COLOUR_DASH_LESSONS } from './colour-dash.js';
import { MAHJONG_SOLITAIRE_LESSONS } from './mahjong-solitaire.js';
import { HEARTS_LESSONS } from './hearts.js';
import { CRAZY_EIGHTS_LESSONS } from './crazy-eights.js';
import { MATE_IN_ONE_LESSONS } from './puzzles/mate-in-1.js';
import { MATE_IN_TWO_LESSONS } from './puzzles/mate-in-2.js';
import { FORK_LESSONS } from './puzzles/fork.js';
import { PIN_LESSONS } from './puzzles/pin.js';
import { SKEWER_LESSONS } from './puzzles/skewer.js';
import { OPENING_LESSONS } from './opening.js';
import { ENDGAME_LESSONS } from './endgame.js';
import { ATTACK_LESSONS } from './attack.js';
import { DEFENSE_LESSONS } from './defense.js';

export * from './moves.js';
export * from './objectives.js';
export * from './piece-power.js';
export * from './rules.js';
export * from './crowning.js';
export * from './backgammon.js';
export * from './bridge.js';
export * from './whist.js';
export * from './rummy.js';
export * from './pirate.js';
export * from './colour-dash.js';
export * from './mahjong-solitaire.js';
export * from './hearts.js';
export * from './crazy-eights.js';
export * from './puzzles/mate-in-1.js';
export * from './puzzles/mate-in-2.js';
export * from './puzzles/fork.js';
export * from './puzzles/pin.js';
export * from './puzzles/skewer.js';
export * from './opening.js';
export * from './endgame.js';
export * from './attack.js';
export * from './defense.js';

/** Every authored lesson, in the order the Learn home grid presents them. */
export const ALL_LESSONS: Lesson[] = [
  ...PIECE_POWER_LESSONS,
  ...MOVE_LESSONS,
  ...RULES_LESSONS,
  ...CROWNING_LESSONS,
  ...BACKGAMMON_LESSONS,
  ...BRIDGE_LESSONS,
  ...WHIST_LESSONS,
  ...HEARTS_LESSONS,
  ...CRAZY_EIGHTS_LESSONS,
  ...RUMMY_LESSONS,
  ...PIRATE_LESSONS,
  ...COLOUR_DASH_LESSONS,
  ...MAHJONG_SOLITAIRE_LESSONS,
  ...OBJECTIVE_LESSONS,
  ...MATE_IN_ONE_LESSONS,
  ...MATE_IN_TWO_LESSONS,
  ...FORK_LESSONS,
  ...PIN_LESSONS,
  ...SKEWER_LESSONS,
  ...OPENING_LESSONS,
  ...ENDGAME_LESSONS,
  ...ATTACK_LESSONS,
  ...DEFENSE_LESSONS,
];
